import React from "react";
import styled from "styled-components";
import Select, { components } from "react-select";

// Styles
import { secondaryDark } from "../utils/colors";

// Components
import { DropdownIcon } from "../icons/dropdown-icon";

const VariantOptions = styled.div`
	max-width: 180px;
	width: 145px;

	margin: 0 15px 0 0;

	cursor: pointer;
`;

const OptionsContainer = styled.div`
	& .product-options__control {
		border-color: inherit;
		border: 0;
		border-radius: 0;
		background-color: transparent;
		box-shadow: none;

		&:hover {
			border-color: inherit;
		}
	}

	& .product-options__menu-list {
		padding: 0;
	}

	& .product-options__single-value {
		color: inherit;
	}

	& .product-options__single-value {
		margin-left: 0;
	}

	& .product-options__value-container {
		padding: 0;
	}

	& .css-tlfecz-indicatorContainer {
		color: inherit;
		padding: 0;
	}

	& .product-options__indicator {
		padding: 0;
	}

	& .product-options__placeholder {
		color: inherit;
		padding-left: 0;

		margin-left: 0;
		margin-right: 0;

		letter-spacing: 0.1em;
		text-transform: uppercase;
	}

	& .product-options__indicator-separator {
		display: none;
	}

	& .product-options__menu {
		border-radius: 0;
		margin-top: 4px;

		& .product-options__option--is-focused {
			background-color: #fff;
		}

		& .product-options__option--is-selected {
			background-color: ${secondaryDark};
			color: #fff;
		}

		&:hover .product-options__option--is-selected {
			background-color: #fff;
			color: inherit;
		}

		& .product-options__option {
			cursor: pointer;

			&:hover {
				background-color: ${secondaryDark};
				color: #fff;
			}
		}
	}

	& .css-b8ldur-Input {
		margin: 0;
	}
`;

export const TechSpecs = ({ options }) => {
	const DropdownIndicator = (props) => {
		return (
			components.DropdownIndicator && (
				<components.DropdownIndicator {...props}>
					<DropdownIcon isOpen={props.selectProps.menuIsOpen} />
				</components.DropdownIndicator>
			)
		);
	};

	const dropdownOptions = options
		.filter((file) => file.tech_specs_pdf !== null)
		.map((file) => {
			return (file = {
				value: file.tech_specs_pdf.url,
				label:
					file.download_title !== "" && file.download_title !== null
						? file.download_title
						: `Tech Specs`,
			});
		});

	return (
		<VariantOptions>
			<OptionsContainer>
				<Select
					options={dropdownOptions}
					placeholder={`Tech Specs`}
					classNamePrefix="product-options"
					onChange={(event) => window.open(event.value)}
					components={{ DropdownIndicator }}
					name={dropdownOptions.name}
					isSearchable={false}
				/>
			</OptionsContainer>
		</VariantOptions>
	);
};
